import React, { Component } from 'react';
import AdminMenu from '../../Modules/AdminMenu';
import MededelingOverzicht from '../../Modules/Mededelingen/Overview';

class MededelingOverview extends Component {

  render() {
    return (
      <div className="route">
      <AdminMenu />
        <h1 className="pageTitle">
          Mededeling overzicht
          </h1>
          <MededelingOverzicht/>
      </div>
    );
  }  
}

export default MededelingOverview;



// WEBPACK FOOTER //
// ./src/components/Admin/Pages/Mededelingen/Overview.js